import { render, staticRenderFns } from "./StandardSelect.vue?vue&type=template&id=0f36e1ef"
import script from "./StandardSelect.vue?vue&type=script&lang=js"
export * from "./StandardSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports